<template>
  <BaseQuestion
    :question-text="questionText"
    :tooltip="tooltipText"
  >
    <div class="w-full mt-4">
      <Textarea
        v-model="answer"
        :placeholder="$t('TextQuestion.placeholder')"
        id="answer-text"
        class="w-full text-question-textarea"
        rows="10"
        @input="onInput"
      />
    </div>
  </BaseQuestion>
</template>

<script>
import { Textarea } from 'primevue';
import BaseQuestion from '@/components/Home/QuestionnaireComponent/questions/BaseQuestion.vue';

export default {
  name: 'TextQuestion',
  components: { Textarea, BaseQuestion },
  computed: {
    question() {
      return this.$store.state.questionnaireManagement.selectedQuestion;
    },
    questionText() {
      return this.question?.properties?.content?.text_question?.[this.getLocale] ?? '';
    },
    tooltipText() {
      return this.question?.properties?.content?.description?.[this.getLocale] ?? null;
    },
    getLocale() {
      return this.$i18n.locale;
    },
    answer: {
      get() {
        return this.$store.state.questionnaireManagement.answer ?? '';
      },
      set(value) {
        this.$store.commit('setAnswer', value);
      },
    },
  },
  methods: {
    onInput(e) {
      this.$store.commit('setAnswer', e.target?.value ?? this.answer);
    },
  },
};
</script>

<style scoped>
.text-question-textarea :deep(.p-inputtextarea) {
  width: 100%;
  min-height: 16rem;
  padding: 0.75rem 1rem;
  font-size: clamp(1rem, 2vw + 0.5rem, 1.125rem);
  line-height: 1.5;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.text-question-textarea :deep(.p-inputtextarea:enabled:focus) {
  border-color: #e4821a;
  box-shadow: 0 0 0 3px rgba(228, 130, 26, 0.2);
  outline: 0;
}
</style>
